export var CLASSNAME_PREFIX = 'av-header';
//# sourceMappingURL=componentConfig.js.map